<template>
    <v-app style="background-color: #cedff2;">
        <main-header></main-header>
        <slot/>
        <section class="home-container">
            <router-link class="home-link" :to="'/'">на главную</router-link>
        </section>
        <MainFooter></MainFooter>
        <div id="vk_community_messages"></div>
    </v-app>
</template>

<script>
    import MainHeader from "../components/MainHeader";
    import MainFooter from "../components/MainFooter";


    export default {
        name: "DefaultLayoutWithVuetify",
        components:{
            MainHeader,
            MainFooter
        },
        mounted(){
            var mode = process.env.NODE_ENV;
            if(mode == "production"){
                let script = "VK.Widgets.CommunityMessages('vk_community_messages', 115982637, {tooltipButtonText: 'Есть вопрос?'});"
                let VKScript = document.createElement('script')
                VKScript.text = script
                document.body.appendChild(VKScript)
            }
        }
    }
</script>



<style scoped>
    .home-container{
        padding-top: 45px;
        padding-bottom: 90px;
        display: flex;
        justify-content: center;
    }

    .home-link{
        user-select: none;
        color: #18224b;
        border: 2px solid #18224b;
        /*font-family: 'Arial',Arial,sans-serif;*/
        font-size: 14px;
        font-weight: 700;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 135px;
        height: 44px;
        text-decoration: none;
        text-transform: uppercase;
    }


</style>